import { call } from './apiHelpers';

export const callControlService = {
  createForSheet: (id, payload) =>
    call('post', `sheets/${id}/calls/`, payload),
  getHistory: (id, voterId) =>
    call('get', `sheets/${id}/calls/`, null, { voter_id: voterId }),
  getSheetHistory: (id) => call('get', `sheets/${id}/calls/`),
};
